module.exports = __webpack_public_path__ + "img/back.f34a5bf7.svg";